// Simple pub/sub for triggering the global login modal without coupling axios to components.
const listeners = new Set();

export function onLoginRequired(callback) {
  if (typeof callback !== 'function') {
    return () => {};
  }
  listeners.add(callback);
  return () => listeners.delete(callback);
}

export function emitLoginRequired() {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (error) {
      console.error('Login modal listener error:', error);
    }
  });
}
